import { RFINotificationEvent } from '@cims-online/shared'
import CIMSNotifications from 'components/CIMSNotifications'
import RecipientsSelectProvider from 'components/CIMSSelect/common/RecipientsSelect/RecipientsSelectContext'
import RFINotificationsProvider, {
  useRFINotificationsContext,
} from './RFINotificationsContext'
import { useEdit } from './hooks/useEdit'
import ViewRFINotifications from './components/ViewRFINotifications'
import RFINotificationsDetails from './components/RFINotificationsDetails'

const InnerNotifications: React.FC = () => {
  const { refetch: onReload, loading } = useRFINotificationsContext()
  const edit = useEdit()
  return (
    <CIMSNotifications
      events={RFINotificationEvent.values}
      edit={edit}
      onReload={onReload}
      view={<ViewRFINotifications />}
      loading={loading}
      details={<RFINotificationsDetails />}
    />
  )
}

const Notifications: React.FC = () => {
  return (
    <RecipientsSelectProvider>
      <RFINotificationsProvider>
        <InnerNotifications />
      </RFINotificationsProvider>
    </RecipientsSelectProvider>
  )
}

export default Notifications
